import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import translationEn from './locales/en.json';

const resources = {
  en: {
    translation: translationEn,
  },
};

export const fallbackLocale = 'en';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',
    fallbackLng: fallbackLocale,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
